<div hidden>
    <ng-template #dialogOverlay>
        <div style="
                position: absolute;
                top: 0;
                left: 0;
                z-index: 1001;
                background-color: #000;
                opacity: 0.3;
                width: 100vw;
                height: 100vh;
            "></div>
    </ng-template>
</div>
<div class="card">
    <form [formGroup]="companySettingsForm" #companySettings="ngForm" id="companySettings">
        <div class="table-container">
            <div class="sticky-table-container">
                <p-table stripedRows *ngIf="rowGroupMetadata" [value]="settings" dataKey="SettingType"
                    [globalFilterFields]="['SettingTypeLabel', 'Description']" (onEditInit)="onEditInit($event)"
                    (onEditComplete)="onEditComplete($event)" (onFilter)="onFilter($event)" (onSort)="onSort($event)"
                    (sortFunction)="customSort($event)" [customSort]="true" [rowHover]="true" #dtSettings
                    [scrollable]="true" scrollHeight="75vh">
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4" style="text-align: center">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template #header let-item>
                        <tr>
                            <th class="status-cell">
                                <i class="pi pi-exclamation-circle" title="Status"></i>
                            </th>
                            <th pSortableColumn="CatDescription">
                                Category
                                <p-sortIcon field="CatDescription" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <!-- <p-columnFilter field="Description" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter" appendTo="body" [options]="categoryItems" [filter]="true" [ngModel]="value"
                                            (ngModelChange)="filter($event)" styleClass="w-full">
                                        </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter> -->
                            </th>
                            <th pSortableColumn="SettingTypeLabel">
                                Setting
                                <p-sortIcon field="SettingTypeLabel" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
                                <p-columnFilter type="text" matchMode="contains" field="SettingTypeLabel" display="menu" class="ml-auto" />
                            </th>
                            <th>
                                Value
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-item let-editing="editing" let-ri="rowIndex">
                        <tr data-id="row-{{ item.SettingType }}">
                            <!-- Status -->
                            <td class="status-cell">
                                <div (click)="onStatusClick(item)" class="status-cell">
                                    <ef-status-icon [status]="item?.Status?.StatusCode"
                                        [message]="item?.Status?.Message"></ef-status-icon>
                                </div>
                            </td>
                            <!-- CatDescription -->
                            <td class="disabled">
                                <strong>{{ item?.CatDescription }}</strong>
                            </td>
                            <!-- SettingTypeLabel -->
                            <td class="disabled">
                                {{ item?.SettingTypeLabel }}
                            </td>
                            <!-- SettingValue -->
                            <td #settingValue [pEditableColumn]="item" [title]="item.ToolTip ?? ''"
                                [pEditableColumnField]="'SettingValue'">

                                <!--CheckBox-->
                                <div *ngIf="item.CtrlType == 'checkbox'">
                                    <div *ngIf="item.Status.StatusCode != 99">
                                        <p-checkbox [disabled]="item.Isreadonly" binary="true" type="checkbox"
                                            [(ngModel)]="item.SettingValue" [name]="item.SettingType" [formControlName]="
                                        item.SettingType
                                    " (onChange)="
                                        checkboxChanged(
                                            $event,
                                            item
                                        )
                                    "></p-checkbox>
                                    </div>
                                    <div *ngIf="item.Status.StatusCode == 99">
                                        <div style="
                                        padding: 0.4rem 0 0 0.4rem;
                                    ">
                                            <ef-status-icon [status]="
                                            item?.Status?.StatusCode
                                        " [message]="
                                            item?.Status?.Message
                                        "></ef-status-icon>
                                        </div>
                                    </div>
                                </div>

                                <!--ComboBox-->
                                <div *ngIf="item.CtrlType == 'combobox'">
                                    <div *ngIf="!item.Isreadonly">
                                        <p-select [style]="{ width: '100%' }"
                                            appendTo="body" [options]="
                                            getValuesForDropdown(
                                                item.SettingType
                                            )
                                        " [(ngModel)]="item.SettingValue" (onChange)="
                                            dropdownChanged(
                                                $event,
                                                item
                                            )
                                        " [formControlName]="
                                            item.SettingType
                                        " [name]="item.SettingType"></p-select>
                                    </div>
                                    <div *ngIf="item.Isreadonly" style="margin-top: .4em; margin-left: .2em;">
                                        {{
                                        getDescriptionForDropdown(
                                        item?.SettingType,
                                        item?.SettingValue
                                        )
                                        }}
                                    </div>
                                </div>

                                <!--TextBox-->
                                <div *ngIf="item.CtrlType == 'textbox'">
                                    <div *ngIf="!item.Isreadonly">
                                        <input pInputText [title]="item.SettingValue" [(ngModel)]="item.SettingValue"
                                            (focus)="$event.target.select()" (input)="
                                            textboxChanged(
                                                item.SettingValue,
                                                item
                                            )
                                        " (blur)="
                                            textboxBlur(
                                                item.SettingValue,
                                                item
                                            )
                                        " [formControlName]="
                                            item.SettingType
                                        " [name]="item.SettingType" />
                                    </div>
                                    <div *ngIf="item.Isreadonly" style="margin-top: .4em; margin-left: .2em;">
                                        {{ item?.SettingValue }}
                                    </div>
                                </div>

                                <!--DatePicker-->
                                <div *ngIf="item.CtrlType == 'datetimepicker'">
                                    <div *ngIf="item.Isreadonly == false">
                                        <p-calendar placeholder="Choose a date..." [style]="{ width: '100%' }"
                                            [monthNavigator]="true" [yearNavigator]="true" yearRange="2010:2030"
                                            [(ngModel)]="item.SettingValue" (onSelect)="
                                            settingChanged($event, item)
                                        " [name]="item.SettingType" [ngModelOptions]="{
                                            standalone: true
                                        }" [appendTo]="calendarWrapper"></p-calendar>
                                    </div>
                                    <div *ngIf="item.Isreadonly == true" style="margin-top: .4em; margin-left: .2em;">
                                        {{
                                        moment(
                                        item?.SettingValue
                                        ).format('MM/DD/YYYY')
                                        }}
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </form>
</div>

<div #calendarWrapper stop-click-propagation></div>
